<template>
    <div class="col d-flex align-items-center justify-content-center p-0">
        <SignUpViaInvest v-if="getWhiteLabel === 'VIA INVEST'" />
        <SignUpNetmoney v-else-if="getWhiteLabel === 'NETMONEY'" />
        <SignUpM7 v-else-if="getWhiteLabel === 'M7'" />
        <SignUpIntrabank v-else-if="getWhiteLabel === 'INTRABANK'" />
        <SingUpIriom v-else-if="getWhiteLabel === 'IRIOM'" />
        <SingUpCarbon v-else-if="getWhiteLabel === 'CARBON'" />
        <SingUpAmb v-else-if="getWhiteLabel === 'AMB'" />
        <SingUpMgpay v-else-if="getWhiteLabel === 'MGPAY'" />
        <SignUp v-else :primaryColor="getIlustraPrimaryColor" :secundaryColor="getIlustraSecundaryColor" />
    </div>
</template>
    
<script>
import SignUp from '@/components/ilustra/SignUp'
import SignUpNetmoney from '@/components/ilustra/SignUpNetmoney'
import SignUpViaInvest from '@/components/ilustra/SignUpViaInvest'
import SignUpM7 from '@/components/ilustra/SignUpM7'
import SignUpIntrabank from '@/components/ilustra/SignUpIntrabank.vue'
import SingUpIriom from '@/components/ilustra/SingUpIriom.vue'
import SingUpCarbon from '@/components/ilustra/SingUpCarbon.vue'
import SingUpAmb from '@/components/ilustra/SingUpAmb.vue'
import SingUpMgpay from '@/components/ilustra/SingUpMgpay.vue'

export default {
    components: {
    SignUp,
    SignUpNetmoney,
    SignUpViaInvest,
    SignUpM7,
    SignUpIntrabank,
    SingUpIriom,
    SingUpCarbon,
    SingUpAmb,
    SingUpMgpay
},
    data() {
        return {
        }
    }
}

</script>
    
<style scoped>
</style>
    